import Vue from 'vue';
import {uploadBtnRenderType} from "@Views/Screening/utility/enums";
Vue.component('history-others', {
    template: `<div class="form-group row align-items-center ml-sm-2">
            <label class="col-sm-2 mb-sm-0">others Start Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="othersObject.start_date"
                       placeholder=""
            />
            <label class="col-sm-2 mb-sm-0">others End Date</label>
            <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                       type="date"
                       v-model="othersObject.end_date"
                       placeholder=""
            />
            <label class="col-sm-2 mb-sm-0">Please upload proof document.</label>
            <upload-btn :fileObj="othersObject.files"
                        :renderType="type.CandidateDetail"
                        :emailAddress="emailAddress"
            />
          </div>`,
    props : {
        othersObject : {
            type : Object,
            required: true
        },
        emailAddress: {
            type: String
        }
    },
    data() {
        return {
            type: uploadBtnRenderType
        }
    }
});





